const BETKN_KEY = "betkn";

export function getDashboardApiToken() {
  return window.localStorage.getItem(BETKN_KEY);
}

export function setDashboardApiToken(token) {
  if (token) {
    window.localStorage.setItem(BETKN_KEY, token);
  }
}

export function clearDashboardApiToken() {
  window.localStorage.removeItem(BETKN_KEY);
}
